import React from 'react'

import { t } from '@/i18n'

interface ITHeadCol {
  type?: string
  colName: string
  onClick?: () => void
}

const THeadCol: React.FC<ITHeadCol> = ({ colName, onClick, type }) => {
  if (type) {
    return (
      <td onClick={onClick}>
        <label>
          <input type="checkbox" />
          <span></span>
        </label>
      </td>
    )
  }
  return (
    <td>
      <p>
        {t(colName)}
        {!!onClick && <span className="icon-sort" onClick={onClick}></span>}
      </p>
    </td>
  )
}

export default THeadCol
